import { Link } from 'react-router-dom';
import {
  ArrowRight, Search, PenTool, Palette, Calculator,
  Layers, ClipboardCheck, Package, Ship, Wrench
} from 'lucide-react';
import { FadeInUp } from '../animations';

const services = [
  { icon: <Search size={24} strokeWidth={1.5} />, title: 'Supplier Identification' },
  { icon: <PenTool size={24} strokeWidth={1.5} />, title: 'Product Development' },
  { icon: <Palette size={24} strokeWidth={1.5} />, title: 'Sampling' },
  { icon: <Calculator size={24} strokeWidth={1.5} />, title: 'Quotation Comparison' },
  { icon: <Layers size={24} strokeWidth={1.5} />, title: 'Production Coordination' },
  { icon: <ClipboardCheck size={24} strokeWidth={1.5} />, title: 'Quality Control' },
  { icon: <Package size={24} strokeWidth={1.5} />, title: 'Packaging Coordination' },
  { icon: <Ship size={24} strokeWidth={1.5} />, title: 'Shipment Coordination' },
  { icon: <Wrench size={24} strokeWidth={1.5} />, title: 'Custom Sourcing' },
];

const ServicesSection = () => (
  <section className="py-24 lg:py-32 bg-[#fafaf9]" data-testid="services-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <FadeInUp className="text-center mb-16">
        <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-[#0B2A57] mb-4" style={{ fontFamily: 'Cabinet Grotesk' }}>
          WHAT TAIGA MANAGES
        </h2>
      </FadeInUp>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {services.map((svc, i) => (
          <FadeInUp key={svc.title} delay={i * 0.05}>
            <div className="flex items-start gap-4 p-5 bg-white border border-[#E5E0D8]/60 hover:shadow-sm transition-all">
              <div className="text-[#1E3D66] flex-shrink-0 mt-0.5">{svc.icon}</div>
              <h3 className="text-sm font-semibold text-[#0B2A57] tracking-wide">{svc.title}</h3>
            </div>
          </FadeInUp>
        ))}
      </div>
      <FadeInUp delay={0.4} className="text-center mt-10">
        <Link to="/services" className="inline-flex items-center gap-2 text-sm font-semibold text-[#1E3D66] tracking-wider uppercase hover:gap-3 transition-all">
          View All Services <ArrowRight size={16} />
        </Link>
      </FadeInUp>
    </div>
  </section>
);

export default ServicesSection;
